import * as React from 'react';

// Components
import Contacts from '../../../common/contacts';

// Constants
import { LIMIT_TYPE } from '../../../constants';

// Modules
import { DI } from 'modules';

const DSARuptlyPassLimitReached = ({ agreement, common = {} }) => {
  const { refill_in } = agreement;
  const { limit_type } = agreement.can_download_content;
  const { customized_limit } = agreement.user_balance;

  const { strings } = common;

  const buyPlanCln = 'side-buy-plan';
  const prefix = 'page.video.slider.ruptly_pass';

  return limit_type === LIMIT_TYPE.DAY_LIMIT ? (
    <>
      <div className={`${buyPlanCln}__text`}>
        {strings[`${prefix}.day_limit_reached.text`]}
      </div>

      <div className={`${buyPlanCln}__text`}>
        {strings[`${prefix}.day_limit_reached.wait1`]}
        {24 - new Date().getUTCHours()}
        {strings[`${prefix}.day_limit_reached.wait2`]}
      </div>
    </>
  ) : (
    <>
      <div className={`${buyPlanCln}__text`}>
        {
          strings[
            `${prefix}.${
              customized_limit ? 'reached_personal_limit' : 'pool.reached'
            }`
          ]
        }
      </div>

      {refill_in && (
        <div className={`${buyPlanCln}__text`}>
          {strings[`${prefix}.poll.refill1`]}
          {refill_in}
          {strings[`${prefix}.poll.refill1`]}
        </div>
      )}

      <Contacts />
    </>
  );
};

export default DI(['common'])(DSARuptlyPassLimitReached);
